import classNames from 'classnames';
import { shuffle } from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { getFormatValues, simplifyMicromag } from '../../../../lib/utils';

import MicromagVideo from '../../../partials/MicromagVideo';
import { Toyota, Montreal, TNM, CPA, Chaudiere } from '../../data';

import styles from '../../../../../styles/guest/sections/content/tool.module.scss';

const propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    active: false,
    className: null,
};

const stories = [Toyota, Montreal, TNM, CPA, Chaudiere];

const Tool = ({ active, className }) => {
    const items = useMemo(() => shuffle(stories.map((s) => simplifyMicromag(s))), [stories]);
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.active]: active,
                },
            ])}
        >
            <div className={styles.description}>
                <h2 className={styles.title}>
                    <FormattedMessage
                        defaultMessage="Your new favorite tool"
                        description="Guest content - title"
                        values={getFormatValues()}
                    />
                </h2>
                <div className={styles.descriptionInner}>
                    <p>
                        <FormattedMessage
                            defaultMessage="Micromag is the ideal format for the digital transformation of your printed magazines, brand publications, internal communications and more."
                            description="Guest content - description"
                            values={getFormatValues()}
                        />
                    </p>
                    <p>
                        <FormattedMessage
                            defaultMessage="You'll not only be able to reach your audience on their phones, but you can also engage with them and collect precise data on how they consume your content."
                            description="Guest content - description"
                            values={getFormatValues()}
                        />
                    </p>
                    <p>
                        <FormattedMessage
                            defaultMessage="Discover our case studies and the detailed benefits of Micromags."
                            description="Guest content - description"
                            values={getFormatValues()}
                        />
                    </p>
                </div>
            </div>
            <div className={styles.micromags}>
                {(items || []).map((story, index) => (
                    <MicromagVideo
                        key={`mm-${story.id}`}
                        story={story}
                        className={classNames([
                            styles.viewer,
                            { [styles[`mm${index + 1}`]]: true },
                        ])}
                    />
                ))}
            </div>
        </div>
    );
};

Tool.propTypes = propTypes;
Tool.defaultProps = defaultProps;

export default Tool;
